import team from './team';
import services from './services';
import projects from './projects';
import products from './products';
import blogs from './blogs'; 



const navbar = [  
    {
        id: 1,
        mainLink : {link: '/', title: '首頁'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '/Policy', title: '關於本服務'},
        subLink: [
            // {id: 1, link: '/About-us', title: 'about us'},
            // {id: 2, link: '/Team', title: 'team'},
            // {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            // {id: 4, link: '/Testimonials', title: 'testimonials'}, 
            // {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink : {link: '/memberCenter', title: '本次停車'},
        subLink: [
            // {id: 1, link: '/Appointment', title: 'Appointment'},
            // {id: 2, link: '/Pricing', title: 'Pricing'},
            // {id: 3, link: '/Login', title: '登入'},
            // {id: 4, link: '/Register', title: 'register'},
            // {id: 5, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 4, 
        mainLink : {link: 'https://rt-mart.parkit.vip', title: '行動繳費'},
        subLink: [
            // {id: 1, link: '/Services', title: 'Services'},
            // {id: 2, link: '/Services/ServiceSingle', title: 'Service Single', state: services[0]}, 
        ],
    }, 
    {
        id: 5, 
        mainLink : {link: '/MonthlyRental', title: '月租申請'},
        subLink: [
            // {id: 1, link: '/Projects', title: 'Projects'},
            // {id: 2, link: '/Projects/ProjectSingle', title: 'Project Single', state: projects[0]},
        ],
    }, 
    {
        id: 6,
        mainLink : {link: '/memberPlateRecords', title: '停車紀錄查詢'},
        subLink: [
            // {id: 1, link: '/Blog-grid', title: 'blog grid'},
            // {id: 2, link: '/Blog-list', title: 'blog list'},
            // {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '/Lots', title: '空車位查詢'},
        subLink: [
            // {id: 1, link: '/Shop-grid', title: 'shop grid'},
            // {id: 2, link: '/Shop-list', title: 'shop list'},
            // {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            // {id: 4, link: '/Wishlist', title: 'wishlist'},
            // {id: 5, link: '/Cart', title: 'cart'},
            // {id: 6, link: '/Checkout', title: 'checkout'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: '聯絡我們'},
        subLink: [],
    },
];

export default navbar;